/* eslint-disable no-lone-blocks */
// evaritho   evariki

// friend : green
// enemy: red
// samePlanet:  black
// neutral:  blue
// unknown : orange
{
  /* 


"(Mo)": {
  "Su": "black",
  "(Su)": "black",
  "Mo": "black",
  "(Mo)": "black",
  "Ma": "black",
  "(Ma)": "black",
  "Me": "black",
  "(Me)": "black",
  "Ju": "black",
  "(Ju)": "black",
  "Ve": "black",
  "(Ve)": "black",
  "Sa": "black",
  "(Sa)": "black",
},


*/
}
const friEneNeu = {
  Su: {
    Su: "#23C0D5",
    "(Su)": "#23C0D5",
    Mo: "green",
    "(Mo)": "green",
    Ma: "green",
    "(Ma)": "green",
    Me: "blue",
    "(Me)": "blue",
    Ju: "green",
    "(Ju)": "green",
    Ve: "red",
    "(Ve)": "red",
    Sa: "orange",
    "(Sa)": "orange",
  },
  "(Su)": {
    Su: "#23C0D5",
    "(Su)": "#23C0D5",
    Mo: "green",
    "(Mo)": "green",
    Ma: "green",
    "(Ma)": "green",
    Me: "blue",
    "(Me)": "blue",
    Ju: "green",
    "(Ju)": "green",
    Ve: "red",
    "(Ve)": "red",
    Sa: "orange",
    "(Sa)": "orange",
  },
  Mo: {
    Su: "green",
    "(Su)": "green",
    Mo: "#23C0D5",
    "(Mo)": "#23C0D5",
    Ma: "blue",
    "(Ma)": "blue",
    Me: "green",
    "(Me)": "green",
    Ju: "blue",
    "(Ju)": "blue",
    Ve: "red",
    "(Ve)": "red",
    Sa: "blue",
    "(Sa)": "blue",
  },
  "(Mo)": {
    Su: "green",
    "(Su)": "green",
    Mo: "#23C0D5",
    "(Mo)": "#23C0D5",
    Ma: "blue",
    "(Ma)": "blue",
    Me: "green",
    "(Me)": "green",
    Ju: "blue",
    "(Ju)": "blue",
    Ve: "red",
    "(Ve)": "red",
    Sa: "blue",
    "(Sa)": "blue",
  },

  Ma: {
    Su: "green",
    "(Su)": "green",
    Mo: "green",
    "(Mo)": "green",
    Ma: "#23C0D5",
    "(Ma)": "#23C0D5",
    Me: "red",
    "(Me)": "red",
    Ju: "green",
    "(Ju)": "green",
    Ve: "blue",
    "(Ve)": "blue",
    Sa: "blue",
    "(Sa)": "blue",
  },

  "(Ma)": {
    Su: "green",
    "(Su)": "green",
    Mo: "green",
    "(Mo)": "green",
    Ma: "#23C0D5",
    "(Ma)": "#23C0D5",
    Me: "red",
    "(Me)": "red",
    Ju: "green",
    "(Ju)": "green",
    Ve: "blue",
    "(Ve)": "blue",
    Sa: "blue",
    "(Sa)": "blue",
  },

  Me: {
    Su: "green",
    "(Su)": "green",
    Mo: "red",
    "(Mo)": "red",
    Ma: "blue",
    "(Ma)": "blue",
    Me: "#23C0D5",
    "(Me)": "#23C0D5",
    Ju: "blue",
    "(Ju)": "blue",
    Ve: "green",
    "(Ve)": "green",
    Sa: "blue",
    "(Sa)": "blue",
  },
  "(Me)": {
    Su: "green",
    "(Su)": "green",
    Mo: "red",
    "(Mo)": "red",
    Ma: "blue",
    "(Ma)": "blue",
    Me: "#23C0D5",
    "(Me)": "#23C0D5",
    Ju: "blue",
    "(Ju)": "blue",
    Ve: "green",
    "(Ve)": "green",
    Sa: "blue",
    "(Sa)": "blue",
  },

  Ju: {
    Su: "green",
    "(Su)": "green",
    Mo: "green",
    "(Mo)": "green",
    Ma: "green",
    "(Ma)": "green",
    Me: "red",
    "(Me)": "red",
    Ju: "#23C0D5",
    "(Ju)": "#23C0D5",
    Ve: "orange",
    "(Ve)": "orange",
    Sa: "blue",
    "(Sa)": "blue",
  },
  "(Ju)": {
    Su: "green",
    "(Su)": "green",
    Mo: "green",
    "(Mo)": "green",
    Ma: "green",
    "(Ma)": "green",
    Me: "red",
    "(Me)": "red",
    Ju: "#23C0D5",
    "(Ju)": "#23C0D5",
    Ve: "orange",
    "(Ve)": "orange",
    Sa: "blue",
    "(Sa)": "blue",
  },

  Ve: {
    Su: "red",
    "(Su)": "red",
    Mo: "red",
    "(Mo)": "red",
    Ma: "blue",
    "(Ma)": "blue",
    Me: "green",
    "(Me)": "green",
    Ju: "blue",
    "(Ju)": "blue",
    Ve: "#23C0D5",
    "(Ve)": "#23C0D5",
    Sa: "green",
    "(Sa)": "green",
  },

  "(Ve)": {
    Su: "red",
    "(Su)": "red",
    Mo: "red",
    "(Mo)": "red",
    Ma: "blue",
    "(Ma)": "blue",
    Me: "green",
    "(Me)": "green",
    Ju: "blue",
    "(Ju)": "blue",
    Ve: "#23C0D5",
    "(Ve)": "#23C0D5",
    Sa: "green",
    "(Sa)": "green",
  },

  Sa: {
    Su: "red",
    "(Su)": "red",
    Mo: "red",
    "(Mo)": "red",
    Ma: "red",
    "(Ma)": "red",
    Me: "green",
    "(Me)": "green",
    Ju: "blue",
    "(Ju)": "blue",
    Ve: "green",
    "(Ve)": "green",
    Sa: "#23C0D5",
    "(Sa)": "#23C0D5",
  },
  "(Sa)": {
    Su: "red",
    "(Su)": "red",
    Mo: "red",
    "(Mo)": "red",
    Ma: "red",
    "(Ma)": "red",
    Me: "green",
    "(Me)": "green",
    Ju: "blue",
    "(Ju)": "blue",
    Ve: "green",
    "(Ve)": "green",
    Sa: "#23C0D5",
    "(Sa)": "#23C0D5",
  },
  "(Ke)": {
    "(Ke)": "#23C0D5",
  },
  "(Ra)": {
    "(Ra)": "#23C0D5",
  },
  Asc: {
    Asc: "#23C0D5",
    Su: "green",
    "(Su)": "green",
    Mo: "green",
    "(Mo)": "green",
    Ma: "green",
    "(Ma)": "green",
    Me: "green",
    "(Me)": "green",
    Ju: "green",
    "(Ju)": "green",
    Ve: "green",
    "(Ve)": "green",
    Sa: "green",
    "(Sa)": "green",
    "(Ra)": "green",
    "(Ke)": "green",
  },
};

export default friEneNeu;
